import DefaultLogo from "./layout/DefaultLogo";

const TermsConditions = () => {
  return (
    <DefaultLogo>
      <div style={{ padding: "10px 4px" }}>
        <h2 className="mb-2" style={{textAlign: "center"}}>Terms & Conditions for the VirtuWard Services</h2>
        <div style={{ marginTop: "20px" }}>
          <h6 style={{ marginBottom: "28px" }}>Effective Date: June 2023</h6>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            1. Introduction
          </h6>
          <p style={{ textAlign: "justify" }}>
            Provide Digital as part of Provide Enterprises Limited{" "}
            <b>(“Provide”, “us”, “our” or “we”)</b> have adopted these terms and
            conditions (together with the documents referred to in them){" "}
            <b>(“Terms”)</b> to govern the use of their digital product -
            VirtuWard web-based software (the main domain of{" "}
            <a href="https://virtuward.com" target="_blank">
              https://virtuward.com
            </a>{" "}
            and its sub-domains, collectively known as the{" "}
            <b>“VirtuWard Application”</b>) by the employees or representatives{" "}
            <b>(“User”, “you”, “your”)</b> of their customers organisation{" "}
            <b>(“employer”)</b>. We are registered in England and Wales under
            company number 12377709 and have our registered office at 900, the
            Crescent, Colchester Business Park, Colchester, England C04 9YQ. We
            offer a variety of content and services, including software, through
            the VirtuWard Application (each such application together with any
            applicable documentation thereto, and programming and user
            interfaces therefor, a <b>“Platform”</b>), collectively the{" "}
            <b>“Services”</b>, which your employer has tailored to its own
            specifications.
          </p>
          <p style={{ textAlign: "justify" }}>
            You have been asked to create a VirtuWard account by your employer
            and these Terms apply and govern your use of the Services. Please
            read these Terms carefully before you start to use the Services.
          </p>
          <p style={{ textAlign: "justify" }}>
            These Terms refer to the following additional policies which also
            apply to your use of the Services. By agreeing to these Terms, you
            also agree to each of these additional policies:
          </p>
          <ul>
            <li>
              our Privacy and Cookie Policies, and Data Processing Agreement
              <b>(DPA)</b>{" "}
              <a href="/privacy-notice" target="_blank">
                (https://virtuward.com/privacy-notice)
              </a>
              , which sets out the terms on which we process any personal data
              we collect from you, or that you provide to us and information
              about the cookies on the Platform and how we will process your
              personal data when we are Data Processor; and
            </li>
            <li>
              our Acceptable Use Policy{" "}
              <a href="/acceptable-use-policy" target="_blank">
                (https://virtuward.com/acceptable-use-policy)
              </a>
              , which sets out the permitted uses and prohibited uses of our
              Services, including any material and data transmitted using the
              Services.
            </li>
          </ul>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            2. Registration
          </h6>
          <p style={{ textAlign: "justify" }}>
            You must be at least 18 years old to use the Services. Your employer
            will normally register you for the Services and you will then be
            asked, via email, to authorise your Services account and create your
            own secure password. Certain questions will be asked about yourself,
            including your name, telephone number, your date of birth, and
            details of your current employment and evidence of current
            qualifications.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            3. User account
          </h6>
          <p style={{ textAlign: "justify" }}>
            When using the Services you must act in good faith and only populate
            your account with accurate, complete and verified (in accordance
            with your employer’s policies and procedures) information as
            prompted by the Platform, and it is your responsibility to keep that
            information up-to-date and truthful. Your employer may rely on the
            information recorded on VirtuWard, for example, to audit the number
            of beds occupied in a particular ward, and it is therefore important
            that the information be accurate at all times.
          </p>
          <p style={{ textAlign: "justify" }}>
            You are responsible for any use of our Services with your account
            details, which includes all user passwords generated, and for
            protecting your account details from unauthorised use. You are also
            responsible for the security of any computer or mobile device from
            which you sign-into your account. You are responsible for
            maintaining the confidentiality of any and all actions that take
            place while using your account and must notify our support team{" "}
            <a href="mailto:info@providedigital.com">
              (info@providedigital.com)
            </a>{" "}
            right away of any actual or suspected loss, theft or unauthorised
            use of your account or account password. We are not responsible for
            any loss that results from unauthorised use of your username and
            password.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>4. Services</h6>
          <p style={{ textAlign: "justify" }}>
            We undertake that the Services will be performed in a professional
            manner in accordance with industry standards using reasonable skill
            and care, and in conformance with the description of the Services in
            these Terms or otherwise set out on our website. This undertaking
            shall not apply to the extent of any non-conformance which is caused
            by your use of the Services contrary to our instructions or these
            Terms, or any alteration or modification made to the Services or the
            software used in the provision of the Services by a third party who
            is not authorised by us. You understand and agree that we have no
            obligation to modify software to support your use of the Services.
          </p>
          <p style={{ textAlign: "justify" }}>
            Our Services are constantly evolving. From time to time, we may
            introduce new services, features or functionality to the Services.
            We may also provide upgrades to fix bugs or correct existing errors.
            These Terms will apply to such new services, features or
            functionality, unless they come with separate or additional terms,
            in which case you will be required to agree to such separate or
            additional terms before being permitted to use the new services,
            features or functionality. Certain of our Services may not properly
            operate if you do not install such updates and you may therefore be
            required to install such updates to ensure functionality of any
            existing Services or new features. You acknowledge and agree that
            the Services may not work properly if you do not allow such updates
            and you expressly consent to automatic updates.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            5. Accessing the Services
          </h6>
          <p style={{ textAlign: "justify" }}>
            Whilst we make reasonable efforts to ensure the Services are
            operational 24 hours a day, 7 days a week, we do not guarantee that
            the Services will always be available or be uninterrupted. In
            particular, but without limitation, the Services will not be
            available to you when we carry out maintenance services. We will
            endeavour to carry out these maintenance services outside of normal
            business hours (being 9:00am to 5:00pm UK time) and to give you at
            least three hours’ notice in writing (via email where possible);
            however you acknowledge that this may not be possible in cases of
            urgency.
          </p>
          <p style={{ textAlign: "justify" }}>
            The Services may be subject to limitations, delays and other
            problems inherent in the use of communication networks and
            facilities. We will not be liable to you if the Services are
            unavailable at any time, or for any period due to an event or cause
            outside of our control.
          </p>
          <p style={{ textAlign: "justify" }}>
            Where a service involves the work of a third party or subcontractor,
            we will confirm the associated service levels separately.
          </p>
          <p style={{ textAlign: "justify" }}>
            We reserve the right to review how you are using the Services if we
            have reasonable cause to do so including your account and/or
            activities conducted through or in any way related to the Services.
            We further reservice the right to suspend your access to or use of
            the Services without notice in the event you breach these Terms or
            if we reasonably suspect that you have breached these Terms or if
            you use the Services inappropriately or at the reasonable request of
            your employer.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            6. Using the Services
          </h6>
          <p style={{ textAlign: "justify" }}>
            You promise and agree that you will only make use of the Services
            within the scope of these Terms, and that you will not redistribute
            or transfer the Services.
          </p>
          <p style={{ textAlign: "justify" }}>You will:</p>
          <ul style={{ textAlign: "justify" }}>
            <li>
              provide us with all necessary cooperation in relation to this
              Agreement and all necessary access to information that we require
              to deliver the Services;
            </li>
            <li>
              comply with all applicable laws and regulations with respect to
              your activities under this Agreement;
            </li>
            <li>
              obtain and maintain all necessary licences, consents and
              permissions necessary for you to perform your obligations and
              exercise your rights under this Agreement, including, without
              limitation, to use the Services;
            </li>
            <li>
              comply with our registration requirements, and thereafter complete
              your account data, with accurate, true and up-to-date data;
            </li>
            <li>
              ensure that your network and systems comply with the relevant
              specifications provided by us from time to time;
            </li>
            <li>
              be solely responsible for procuring and maintaining your network
              connections and telecommunications links from your systems to our
              data centres, and for all problems, conditions, delays, delivery
              failures and all other loss or damage arising from or relating to
              your network connections or telecommunications links or caused by
              the internet; and
            </li>
            <li>
              be solely responsible for the management of your User Generated
              Content and will only post or upload User Generated Content that
              is yours and which you have permission to post or upload.
            </li>
          </ul>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            7. Intellectual Property Rights and Rights we grant you
          </h6>
          <p style={{ textAlign: "justify" }}>
            For the purposes of these Terms:
          </p>
          <p style={{ textAlign: "justify" }}>
            <b>Content:</b> means any form of information or data and includes,
            without limitation, photographs, images, illustrations, animations,
            tools, texts, tables, communications, replies, likes, and any other
            intellectual property therein any of which may be generated,
            provided or otherwise made accessible on or through the Services.
          </p>
          <p style={{ textAlign: "justify" }}>
            <b>Employer Content:</b> means all Content that is not
            User-Generated Content.
          </p>
          <p style={{ textAlign: "justify" }}>
            <b>Intellectual Property Rights:</b> means patents, utility models,
            rights to inventions, copyright and related rights, trade marks and
            service marks, trade names and domain names, rights in get-up,
            goodwill and the right to sue for passing off or unfair competition,
            rights in designs, rights in computer software, database rights,
            rights to preserve the confidentiality of information (including
            know-how and trade secrets) and any other intellectual property
            rights, including all applications for (and rights to apply for and
            be granted), renewals or extensions of, and rights to claim priority
            from, such rights and all similar or equivalent rights or forms of
            protection which subsist or will subsist, now or in the future, in
            any part of the world.
          </p>
          <p style={{ textAlign: "justify" }}>
            <b>User-Generated Content:</b> means any Content that a user
            submits, posts, uploads, transfers, or otherwise provides to or
            through the use of the Services.
          </p>
          <h6 style={{ textDecorationLine: "underline" }}>
            Ownership of Intellectual Property Rights
          </h6>
          <p style={{ textAlign: "justify" }}>
            You agree that all Intellectual Property Rights:
          </p>
          <ul>
            <li>
              in the Services anywhere in the world belong to Provide or its
              licensors and that you have no rights in or to the Services other
              than as expressly set out in this Agreement;
            </li>
            <li>
              in Employer Content and updates thereof belong and shall belong to
              your employer; and
            </li>
            <li>
              in User Generated Content belongs to you subject to any employer
              rights.
            </li>
          </ul>
          <h6 style={{ textDecorationLine: "underline" }}>
            Our licence to you
          </h6>
          <p style={{ textAlign: "justify" }}>
            Provide retains ownership and responsibility for, and other
            applicable rights, in the Services. Except as expressly provided in
            these Terms nothing grants you a right or licence to use the
            Services, including any Employer Content which is owned and / or
            controlled by your employer. You agree not to duplicate publish,
            display modify or create derivative works from the software,
            Platform or material presented through the Services unless
            specifically authorised to do so by us.
          </p>
          <p style={{ textAlign: "justify" }}>
            Subject to your compliance with these Terms, we grant you a limited,
            revocable, personal, non-transferable, and non-exclusive right and
            licence to access and use the Services for your own personal,
            non-commercial purposes, provided that you do not (and do not allow
            any third party to) copy, modify, create a derivative work from,
            reverse engineer, sell, assign, sublicense, grant a security
            interest in, transfer or otherwise commercially exploit any right in
            the Services.
          </p>
          <p style={{ textAlign: "justify" }}>
            We also hereby grant you a limited personal non-exclusive
            non-transferable non sublicensable revocable licence to use the
            VirtuWard Application downloaded directly from a legitimate market
            place, solely in object code format and solely for your personal use
            for lawful purposes.
          </p>
          <p style={{ textAlign: "justify" }}>
            We are giving you personally the right to access and use the
            Services. If others you know wish to access the Services they should
            create their own account.
          </p>
          <p style={{ textAlign: "justify" }}>
            This licence granted to you to use of the Services does not permit
            you to do, and you shall not do nor permit any third party to do,
            any of the following:
          </p>
          <ul>
            <li>
              embed our Services into any product of yours or any third party;
            </li>
            <li>
              make available through automated or manual means any part of the
              Services by way of crawling, scraping, spidering or otherwise;
            </li>
            <li>
              copy or access all or any part of the Services other than via the
              interface(s) provided to you by us; or
            </li>
            <li>
              circumvent or attempt to override any security features we have
              installed around the Services.
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            You further agree to comply with the Acceptable Use Policy with
            regards to your use of the Services, including any material and data
            you transmit using the Services. This Acceptable Use Policy is
            hereby incorporated into these Terms. A breach of the Acceptable Use
            Policy will constitute a breach of these Terms, and may result in
            termination or suspension of your account in accordance with these
            Terms.
          </p>
          <p style={{ textAlign: "justify" }}>
            We make no representations or warranties as to the accuracy,
            reliability, completeness of any Content available through the
            Services, and we make no commitment to update such Content. In
            addition, User-Generated Content however transmitted is the sole
            responsibility of the user from whose such User-Generated Content
            originated. All Content is provided as is without any representation
            warranty or condition as to its accuracy or reliability.{" "}
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            8. Rights you give us
          </h6>
          <p style={{ textAlign: "justify" }}>
            We claim no Intellectual Property Rights in and to any
            User-Generated Content. All User-Generated Content belong to you.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            When you provide User-Generated Content to Provide through the
            Services, you grant us a non-exclusive, irrevocable, royalty-free,
            freely transferable, sublicensable, worldwide right and licence to
            use, host, store, cache, reproduce, publish, display (publicly or
            otherwise), perform (publicly or otherwise), distribute, transmit,
            modify, adapt (including, without limitation, in order to conform to
            the requirements of any networks, devices, services, or media
            through which the Services are available), commercialise, create
            derivative works of, and otherwise exploit such User-Generated
            Content in connection with any and all Services. You acknowledge and
            agree that: (a) we have the right to arrange the posting of
            User-Generated Content in any way we desire; and (b) you are not
            entitled to any compensation or other payment from us in connection
            with the use of your User-Generated Content.
          </p>
          <p style={{ textAlign: "justify" }}>
            The rights you grant in this licence are for the limited purposes of
            allowing Provide to operate and allow other users to use the
            Services in accordance with their functionality, improve the
            Services, and develop new Services. Notwithstanding the above, we
            will not make use of any of your User-Generated Content in a manner
            that is inconsistent with our Privacy Policy.
          </p>
          <p style={{ textAlign: "justify" }}>
            We reserve the right to monitor, remove or modify User-Generated
            Content for any reason and at any time, including User-Generated
            Content we believe violates these Terms, any guidelines, and/or our
            policies.
          </p>
          <p style={{ textAlign: "justify" }}>
            You agree you will respect the Intellectual Property Rights of
            others. You represent and warrant you have all the necessary rights
            to grant Provide the foregoing licence for all User-Generated
            Content you submit in connection with the Services and will
            indemnify us for any breach of this representation and warranty.
          </p>
          <p style={{ textAlign: "justify" }}>
            This licence shall remain in effect unless and until you email us at
            info@providedigital.com and expressly ask us to delete such data
            from our database. For the avoidance of doubt, this licence will not
            end upon termination of these Terms.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            9. Data Protection and Privacy
          </h6>
          <p style={{ textAlign: "justify" }}>
            We will use User Generated Content only in order to provide the
            Services to you and only as permitted by applicable law, these
            Terms, our Privacy Notice and Data Processing Agreement
            <a href="/privacy-notice" target="_blank">
              (https://virtuward.com/privacy-notice)
            </a>
            .
          </p>
          <p style={{ textAlign: "justify" }}>
            For the purposes of providing the Services, we may collect, process
            and store certain data including personal data, for which we will be
            the Data Processor (and you and/or your employer will be the Data
            Controller) in accordance with these Terms.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            For the purposes of this Agreement, Data Protection Laws means (i)
            The Data Protection Act 2018 and Regulation 2016/679 of the European
            Parliament and of the Council on the protection of natural persons
            with regard to the Processing of Personal Data and on the free
            movement of such data (General Data Protection Regulation) (the
            "GDPR"); (ii) the EU e-Privacy Directive (Directive 2002/58/EC); and
            (iii) any and all applicable national data protection laws made
            under or pursuant to (i), (ii); in each case as may be amended or
            superseded from time to time; and{" "}
            <b>
              “Personal Data”, “Data Subject”, “Data Controller”, “Data
              Processor” and “Process”
            </b>{" "}
            shall have the meaning given to them by the Data Protection Laws.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            10. Security
          </h6>
          <p style={{ textAlign: "justify" }}>
            Provide will implement appropriate technical and organisational
            measures to protect your confidential information and data against
            unauthorised or unlawful processing and accidental loss or damage.
            For the avoidance of doubt and subject to clause 8, Provide shall
            not have any access to User-Generated Content, without your
            agreement or that of your employer.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            11. Limitation of liability
          </h6>
          <p style={{ textAlign: "justify" }}>
            You agree to the following limitations on our liability to each
            other:
          </p>
          <ul>
            <li>Exclusion of certain losses:</li>
            <ul>
              <li>
                we shall not be liable to each other for any loss of profits,
                business, anticipated savings, goodwill or business opportunity,
                business interruption, loss or corruption of data or
                information, or for any special, indirect or consequential loss
                or damage, howsoever arising under these Terms;
              </li>
            </ul>
            <li>
              Exclusions of certain losses because of the nature of this
              Agreement: to the extent permitted by applicable law:
            </li>
            <ul>
              <li>
                we are not liable to each other for Loss suffered as a result of
                your access to use or inability to access or use the Services;
              </li>
              <li>
                we are not liable to each other for any claims arising out of
                your use of the Services, the use, disclosure, display or
                maintenance of a user’s personal data or any other interactions
                with us or any other users of the services even if we have been
                advised of the possibility of such damages;{" "}
              </li>
              <li>
                we do not take responsibility for any damage or loss caused by
                errors or omissions in any content, information (including
                medication schedules) or instructions provided by you to us in
                connection with the Services, actions taken on the basis of any
                User-Generated Content, and any recommendations by you or
                assessments made by you;
              </li>
              <li>
                we do not take responsibility for any damage or loss caused by
                errors or omissions in any User-Generated Content; and
              </li>
              <li>
                we do not take responsibility for any damage or loss caused by
                errors or omissions in any Content, including Employer Content.
              </li>
            </ul>
            <li>
              Cap on liability: Our maximum aggregate liability to each other in
              contract, tort (including negligence or breach of statutory duty),
              misrepresentation, restitution or otherwise, arising in connection
              with the performance or contemplated performance of these Terms
              shall be limited to £100.
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            Nothing in these Terms shall exclude either party’s liability for
            death or personal injury caused by negligence, fraud or fraudulent
            misrepresentation or any other liability or responsibility that
            cannot be excluded or limited by law. All warranties, conditions,
            representations or other terms implied by statute or common law in
            relation to the Services, and the Platform provided by us are
            excluded to the fullest extent permitted by law.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            12. Indemnity
          </h6>
          <p style={{ textAlign: "justify" }}>
            Subject to the cap on liability in clause 11 above, you will defend,
            indemnify and hold harmless Provide against claims, actions,
            proceedings, losses, damages, expenses and costs (including without
            limitation court costs and reasonable legal fees) arising out of or
            in connection with your use of the Services, Service data or
            Platform in breach of these Terms or other agreements referred to in
            these Terms (including, but not limited to, the Acceptable Use
            Policy).
          </p>
          <p style={{ textAlign: "justify" }}>
            Subject to the cap on liability in clause 11 above, Provide will
            defend, indemnify and hold you harmless against claims, actions,
            proceedings, losses, damages and costs arising out of any claim made
            against you by a third party alleging infringement of their
            Intellectual Property Rights through or in connection with your use
            of the Services as long as:
          </p>
          <ul>
            <li>you give us prompt notice of any claim;</li>
            <li>
              you provide us reasonable co-operation in the defence and
              settlement of such claim, at our expense; and
            </li>
            <li>you give us sole authority to defend or settle the claim.</li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            In the defence or settlement of any such claim, we may procure the
            right for you to continue using the Services replace or modify the
            Services so that they become non-infringing or terminate this
            agreement without any additional liability or obligation to pay you
            damages or additional costs.
          </p>
          <p style={{ textAlign: "justify" }}>
            This clause 12 sets out your sole and exclusive rights and remedies,
            and our entire obligations and liability, for infringement of any
            third party Intellectual Property Rights.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            13. Termination{" "}
          </h6>
          <p style={{ textAlign: "justify" }}>
            We may terminate these Terms with you immediately, without notice,
            in the event you commit a material or persistent breach of these
            Terms (including the Acceptable Use Policy), the Services are
            discontinued, we lose the right to provide you with the Services, or
            where the provision of the Services becomes unlawful.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            If you request access to copies of data supplied by you to the
            Platform, we will provide this to you in electronic form within 5
            working days of your request.{" "}
          </p>
          <p style={{ textAlign: "justify" }}>
            Upon termination of these terms:
          </p>
          <ul>
            <li>
              all rights granted to you under these Terms, including the right
              of access in clause 7, shall cease;
            </li>
            <li>
              you must cease all activities authorised by these Terms, including
              use of the Services, Service data and Platform; and
            </li>
            <li>
              you must immediately uninstall, delete or remove from all computer
              equipment in your possession or control, and destroy or return to
              us all copies of, any software used in the provision of the
              Services.
            </li>
          </ul>
          <p style={{ textAlign: "justify" }}>
            Upon termination of your employment contract with an employer, our
            licences to you as set out in Clause 7 and these Terms generally
            shall be suspended but shall continue upon you being engaged by a
            new employer who is registered with the Services .{" "}
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            14. Confidentiality
          </h6>
          <p style={{ textAlign: "justify" }}>
            You and Provide agree that each shall maintain the confidentiality
            of and shall not disclose to any third party all confidential
            documents and information of the other party, its respective
            vendors, licensors and other third parties, that such party may
            furnish (the <b>“Disclosing Party”</b>) to the other party or which
            the Disclosing Party makes available to the other party (the{" "}
            <b>“Receiving Party”</b>) and that the Disclosing Party treats as
            confidential, including without limitation, business information,
            customer and client lists, pricing of products or services,
            technology, agreements, business plans, software, technical
            documentation, and other information which is not publicly
            available.
          </p>
          <p style={{ textAlign: "justify" }}>
            The Receiving Party agrees to use all such information solely for
            the performance of its obligations under this Agreement. The
            parties’ obligations under this provision shall survive termination
            of this Agreement, but such obligations shall not include
            information that is or becomes part of the public domain through no
            act or omission of the Receiving Party or breach by the Receiving
            Party of this Agreement.
          </p>

          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            15. Other important terms
          </h6>
          <p style={{ textAlign: "justify" }}>
            <u>Update to these Terms:</u> We reserve the right to modify these
            Terms by (i) posting revised Terms on and/or through the Services,
            and/or (ii) providing advance notice to you of material changes to
            the Terms, generally via email where practicable, and otherwise
            through the Services (such as through a notification on the home
            page of the VirtuWard website or in-app). Modifications will not
            apply retroactively unless required by law.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Assignment and other dealings:</u> You may not assign, transfer,
            sub-licence or deal in any other manner with any or all of your
            rights under these Terms, without our prior written consent.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Waiver:</u> A waiver of any right or remedy under these Terms or
            by law is only effective if given in writing and shall not be deemed
            a waiver of any subsequent breach or default. A failure or delay by
            a party to exercise any right or remedy provided under these Terms
            or by law shall not constitute a waiver of that or any other right
            or remedy, nor shall it prevent or restrict any further exercise of
            that or any other right or remedy.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Severance:</u> If any provision or part-provision of these Terms
            is or becomes invalid, illegal or unenforceable, it shall be deemed
            modified to the minimum extent necessary to make it valid, legal and
            enforceable. If such modification is not possible, the relevant
            provision or part-provision shall be deemed deleted. Any such
            modification to or deletion of a provision or part-provision shall
            not affect the validity and enforceability of the rest of these
            Terms.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Relationship:</u> Nothing in these Terms is intended to, or shall
            be deemed to, establish any partnership or joint venture between any
            of the parties or constitute any party the agent of another party.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Third Party Rights:</u> No one other than a party to these Terms,
            their successors and permitted assignees, shall have any right to
            enforce any of its terms.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Entire Agreement:</u> These Terms and all documents referred to
            in them, constitute the entire agreement between the parties and
            supersedes and extinguishes all previous agreements, promises,
            assurances, warranties, representations and understandings between
            them, whether written or oral, relating to its subject matter.
          </p>
          <p style={{ textAlign: "justify" }}>
            <u>Jurisdiction/Governing Law:</u> These Terms, their subject matter
            and its formation (including any non-contractual disputes or claims)
            are governed by English law and we both agree to the exclusive
            jurisdiction of the courts of England and Wales.
          </p>
          <h6 style={{ margin: "10px 0px", fontWeight: "700" }}>
            16. Contact us
          </h6>
          <p style={{ textAlign: "justify" }}>
            To contact us, or if you are experiencing problems with the
            Services, please email{" "}
            <a href="mailto:info@providedigital.com">info@providedigital.com</a>
            .{" "}
          </p>
        </div>
      </div>
    </DefaultLogo>
  );
};

export default TermsConditions;
